export const DASHBOARD_PREFIX = '/';

export const TOP_CONTRIBUTORS_REQUESTED = `${DASHBOARD_PREFIX}TOP_CONTRIBUTORS_REQUESTED`;

export const TOP_CONTRIBUTORS_SUCCEEDED = `${DASHBOARD_PREFIX}TOP_CONTRIBUTORS_SUCCEEDED`;

export const TOP_CONTRIBUTORS_FAILED = `${DASHBOARD_PREFIX}TOP_CONTRIBUTORS_FAILED`;

export const TOP_TAGS_REQUESTED = `${DASHBOARD_PREFIX}TOP_TAGS_REQUESTED`;

export const TOP_TAGS_SUCCEEDED = `${DASHBOARD_PREFIX}TOP_TAGS_SUCCEEDED`;

export const TOP_TAGS_FAILED = `${DASHBOARD_PREFIX}TOP_TAGS_FAILED`;

export const ACTIVITY_CALENDAR_REQUESTED = `${DASHBOARD_PREFIX}ACTIVITY_CALENDAR_REQUESTED`;

export const ACTIVITY_CALENDAR_SUCCEEDED = `${DASHBOARD_PREFIX}ACTIVITY_CALENDAR_SUCCEEDED`;

export const ACTIVITY_CALENDAR_FAILED = `${DASHBOARD_PREFIX}ACTIVITY_CALENDAR_FAILED`;

export const PIECES_COLLECTED_REQUESTED = `${DASHBOARD_PREFIX}PIECES_COLLECTED_REQUESTED`;

export const PIECES_COLLECTED_SUCCEEDED = `${DASHBOARD_PREFIX}PIECES_COLLECTED_SUCCEEDED`;

export const PIECES_COLLECTED_FAILED = `${DASHBOARD_PREFIX}PIECES_COLLECTED_FAILED`;
